// Single source of truth for the Google Maps JS loader.
//
// @react-google-maps/api's loader is a GLOBAL singleton: every useJsApiLoader
// call in the app shares one <script>, and the loader throws
//   "Loader must not be called again with different options"
// if two components request it with different `id`/`libraries`/etc. (e.g. the
// property map defaulting to ["maps"] while the property form asks for
// ["places"]). That crash is per-session and only clears on a hard refresh.
//
// Import this object and pass it verbatim to every useJsApiLoader call so the
// options — and the `libraries` array identity — are always identical.
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: "google-map-script",
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  libraries: ["places"],
};
